import ReactPlayer from 'react-player';

import { Disclosure } from '../../components';
import Step1 from '../../assets/images/step_1.png';
import Step2 from '../../assets/images/step_2.png';
import Step3 from '../../assets/images/step_3.png';
import Step4 from '../../assets/images/step_4.png';
import Step5 from '../../assets/images/step_5.png';
import Step6 from '../../assets/images/step_6.png';
import Step7 from '../../assets/images/step_7.png';

const HowItWorks = () => (
  <div className='border-t-2'>
    <div className='max-w-[830px] py-6 px-8 flex flex-col mx-auto items-start sm:px-4'>
      <div className='relative w-full pb-[57.3%] sm:pb-[100%]'>
        <ReactPlayer
          url='https://player.vimeo.com/video/698608034'
          controls
          className='video video_full-rounded absolute overflow-hidden'
        />
      </div>
      <p className='text-xs leading-xs text-center w-full opacity-50 mb-4 mt-1'>How to install brushes short video</p>

      <Disclosure title='How to install brushes?'>
        <ul className='mb-16 text-base leading-base sm:text-lg sm:leading-sm sm:mb-12'>
          <li className='mb-10'>
            <p className='mb-3'>1. Tap to download button</p>
            <img src={Step1} alt='screenshot' />
          </li>
          <li className='mb-10'>
            <p className='mb-3'>2. Choose Procreate</p>
            <img src={Step2} alt='screenshot' />
          </li>
          <li>
            <p className='mb-3'>3. Your new brush will be in “imported” section</p>
            <img src={Step3} alt='screenshot' />
          </li>
        </ul>
      </Disclosure>
      <Disclosure title='How to use stickers and interior design?'>
        <ul className='mb-16 sm:mb-12 text-base leading-base sm:text-lg sm:leading-sm'>
          <li>
            <p className='mb-4'>1. Tap on Save image</p>
          </li>
          <li>
            <p className='mb-4'>2. Open Photos and Procreate simultaneously</p>
          </li>
          <li>
            <p className='mb-4'>3. Drag and Drop Stickers and Interior elements</p>
          </li>
          <li className='relative w-full pb-[57.3%] sm:pb-[100%]'>
            <ReactPlayer
              url='https://player.vimeo.com/video/705656589'
              controls
              className='video video_full-rounded absolute overflow-hidden'
            />
          </li>
          <p className='text-xs leading-xs text-center w-full opacity-50 mb-4 mt-1'>
            How to use stickers and interior design
          </p>
        </ul>
      </Disclosure>
      <Disclosure title='I do not have procreate icon'>
        <ul className='mb-16 sm:mb-12 text-base leading-base sm:text-lg sm:leading-sm'>
          <li>
            <p className='mb-3'>Just jump on more choose Procreate</p>
          </li>
          <li>
            <img src={Step4} alt='screenshot' />
          </li>
        </ul>
      </Disclosure>
      <Disclosure title='How to add web app to home screen?'>
        <ul className='mb-16 sm:mb-12 text-base leading-base sm:text-lg sm:leading-sm'>
          <li className='mb-10'>
            <p className='mb-3'>1. Tap to share button</p>
            <img src={Step5} alt='screenshot' />
          </li>
          <li className='mb-10'>
            <p className='mb-3'>2. Choose “Add to Home Screen”</p>
            <img src={Step6} alt='screenshot' />
          </li>
          <li className='mb-10'>
            <p className='mb-3'>3. Tap to Add button</p>
            <img src={Step7} alt='screenshot' />
          </li>
        </ul>
      </Disclosure>
    </div>
  </div>
);

export { HowItWorks };
